import { APP_CONFIG } from "../constants/global-variables.js";

export async function getLiveSports() {
    const url = `${APP_CONFIG.URL.apiBasePath}ajax/livesports`;

    try {
        const res = await axios.get(url, {
            headers: {
            },
        });

        return res.data;
    } catch (err) {
        console.log("Error getting documents");
    }
}
